import ajax from '../http/ajax'

export const getPaymentsList = params => {
    return ajax.get('getPaymentsList', params)
}
